import styled from 'styled-components'

export const Box = styled.div`
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;

    flex-direction: ${ props => props.row ? 'row' : 'column' };

    gap: ${ props => props.gap || '2em' };

    @media print {
        gap: ${ props => props.row ? '0.75em' : '1em' };
    }

    ${ props => props.s }
`
